import React from 'react';
import { useRef } from "react";
import { useState } from 'react';
import { useEffect } from 'react';
import '../../../cssFiles/productPages.scss';
import Footer from '../../layouts/footer';
import Headers from '../../layouts/header';
import { StatisticCard } from '@ant-design/pro-components';
import 'antd/dist/reset.css';
import Celebration from '../../layouts/celebration';
// import { BiArrowFromLeft, BiArrowFromRight } from 'react-icons/bi';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { FaAngleRight, FaAngleLeft} from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import { Navigation } from "swiper/modules";
import { FaArrowUp, FaArrowDown } from "react-icons/fa";
// import YouTube from 'react-youtube-embed';
import YoutubeTestimonials from '../youtubeReviews/YoutubeTestimonials'
import ProductCards from '../productComparison/productCards';
import { leadServiceHelper } from '../../../services/leadServices';

const features = [
  {
    icon: '/images/premium/money_stays_with_you03012019.png',
    title: 'PMS Service & AIF Fund Alternative',
    desc: 'PMS & AIF like service at affordable cost. Start with just 5 lac capital.'
  },
  {
    icon: '/images/premium/performance_gaurantee_orange.png',
    title: 'Service Guarantee',
    desc: 'No annual renewals fees, service continues until returns delivered.'
  },
  {
    icon: '/images/premium/no-profits-sharing.png',
    title: 'No Profit Sharing',
    desc: 'Unlike PMS, 100% profits are yours. No hidden charges beyond our fees.'
  },
  {
    icon: '/images/premium/no-lock-in-period.png',
    title: 'No Lock-In Period',
    desc: 'You can exit anytime. No lock-in or exit load.'
  },
  {
    icon: '/images/premium/zero_brokerage03012019.png',
    title: 'Free Brokerage & Dealer',
    desc: "Brokerage fees eat your capital! Dedicated dealer at your service."
  },
  {
    icon: '/images/premium/risk_orange4.png',
    title: 'Risk Management',
    desc: 'Robust risk controls to shield the capital from market volatility.'
  },
  {
    icon: '/images/premium/flexible.png',
    title: 'Balanced Strategy',
    desc: 'Blend of value and growth stocks.'
  },
  // {
  //   icon: '/images/premium/Free_Portfolio_Checkup_D.png',
  //   title: 'Free Portfolio Review',
  //   desc: 'Review existing portfolio from our experts.'
  // },
  {
    icon: '/images/premium/360research_reports_ornage.png',
    title: '360° Research Reports',
    desc: 'Detailed research reports with every stock.'
  },
  // {
  //   icon: '/images/premium/Research-Desk-Access-new.png',
  //   title: 'Research Desk Access',
  //   desc: 'Direct access to the Research Desk.'
  // }
];

const plans = [
  // {
  //   title: 'p360° Momentum',
  //   returns: '5-10% returns objective* over 2-6 Weeks',
  //   price: '₹20000 + GST',
  //   timeLimit: 'No Time Limit',
  //   stocks: '20 Stocks',
  //   button: 'Learn More',
  //   strategy: 'Momentum Strategy',
  //   guarantee: 'No Service Guarantee',
  //   research: '360° Research Note (1 Page)',
  //   mainPage:  '/products/momentum' 

  // },
  {
    title: 'p360° Mid Term',
    returns: '20-25% returns objective* over 6-9 months',
    price: '₹15000 + GST',
    timeLimit: 'Service active until 10 stocks delivered',
    stocks: ' ',
    button: 'Learn More',
    strategy: 'Growth Strategy',
    guarantee: 'No Service Guarantee',
    research: '360° Research Reports (4 Pages)',
    mainPage:  '/products/midterm' 
  },
  {
    title: 'p360° Long Term',
    returns: 'More than 50% returns objective* over 1-2 years!',
    price: '₹15000 + GST',
    timeLimit: 'Service active until 5 stocks delivered',
    stocks: ' ',
    button: 'Learn More',
    strategy: 'Growth+Value Strategy',
    guarantee: 'No Service Guarantee',
    research: '360° Research Reports (8 Pages)',
    mainPage:  '/products/longterm'  
  },
  {
    title: 'p360° Multibagger',
    popular: false,
    returns: 'More than 100% returns objective* over 2-3 years',
    price: '₹25000 + GST',
    timeLimit: 'Service active until 5 stocks delivered',
    stocks: ' ',
    button: 'Learn More',
    strategy: 'Balanced Strategy',
    guarantee: 'Service Guarantee',
    research: 'Research Desk Access',
    mainPage:  '/products/multibagger' 
  },
];

const researchCalls = [
  {
    name: 'Jubilant Ingrevia',
    entry: '₹ 699',
    exit: '₹ 844',
    entryDate:'8 May 2025',
    exitDate:'17 July 2025',
    returns: '20.7%',
    trend: 20.7
  },
  {
    name: 'RattanIndia Ent',
    entry: '₹ 40.8',
    exit: '₹ 65.5',
    entryDate:'6 Mar 2025',
    exitDate:'11 Jun 2025',
    returns: '60.54%',
    trend: 60.54
  },
  {
    name: 'Faze Three Ltd',
    entry: '₹ 338',
    entryDate:'27 Feb 2025',
    exitDate:'09 Apr 2025',
    exit: '₹ 442',
    returns: '30%',
    trend: 30
  },
    {
    name: 'Apollo Micro Sys.',
    entry: '₹ 121',
    entryDate:'13 Jan 2025',
    exitDate:'16 May 2025',    
    exit: '₹ 140',
    returns: '19.6%',
    trend: 19.6
  },
  {
    name: 'Techno Electric',
    entry: '₹ 1077',
    exit: '₹ 1600',
    entryDate:'9 Apr 2025',
    exitDate:'27 Jun 2025',   
    returns: '48.56%',
    trend: 48.56
  },
  {
    name: 'Dredging Corp.',
    entry: '₹ 580',
    exit: '₹ 696',
    entryDate:'01 Apr 2025',
    exitDate:'19 May 2025',    
    returns: '20%',
    trend: 20
  },
    {
    name: 'Anantraj Ltd',
    entry: '₹ 306',
    exit: '₹ 334',
    entryDate:'18 Jan 2024',
    exitDate:'05 Feb 2024',    
    returns: '9%',
    trend: 	9
  },
  {
    name: 'Shakti pump',
    entry: '₹ 1149',
    exit: '₹ 1480',
    entryDate:'18 Jan 2024',
    exitDate:'30 Jan 2024',    
    returns: '29%',
    trend: 29
  },
  {
    name: 'PNB',
    entry: '₹ 130',
    exit: '₹ 122',
    entryDate:'20 Feb 2024',
    exitDate:'5 Mar 2024',    
    returns: '-6%',
    trend: -6
  }
];

const Premium = () => {


    const [form, setForm] = useState({ name: '', mobile: '', email: '' });
    const [submitted, setSubmitted] = useState(false);
    const prevRef = useRef(null);
    const nextRef = useRef(null);
    const [swiperReady, setSwiperReady] = useState(false);
    const [productFeatures, setProductFeatures] = useState([]);
    const [expanded, setExpanded] = useState(false);
    const navigate = useNavigate();
    const [otpSent, setOtpSent] = useState(false);
    const [otp, setOtp] = useState('');
    const [otpModalOpen, setOtpModalOpen] = useState(false);

    const handleFormChange = (e) => {
      setForm({ ...form, [e.target.name]: e.target.value });

      // let inputData = e.target.value
      // inputData = inputData.replace(/[^0-9]/g, "");
      // console.log('inputData:',inputData)
      // if(e.target.value && e.target.value.length <11){
      //   setForm({ ...form, [e.target.name]: e.target.value });
      // }
    };
    useEffect(() => {
      // Ensure Swiper re-renders after refs are attached
      window.scrollTo(0, 0);
      setSwiperReady(true);
      if (window.innerWidth <= 500) {
        setProductFeatures(features.slice(0, 4));
      } else {
        setProductFeatures(features.slice(0, 6));
      }
    }, []);

    const handleFormSubmit = (e) => {
        e.preventDefault();
        setSubmitted(true);
        // You can add your submit logic here (API call, etc.)
        console.log('form:',form)
        leadServiceHelper.submitMobileNumberService(form,()=>{
          setTimeout(() => setSubmitted(false), 2000);
          setForm({ name: '', mobile: '', email: '' });
          navigate('/products/premium/thankyou',{ state: { product: 'premium' } });
        })

    };
    // const handleFormSubmit = (e) => {
    //   e.preventDefault();

    //   const mobileWithCountryCode = "91" + form.mobile;

    //   if (!otpSent) {
    //     // STEP 1: Send OTP
    //     console.log('debug:sending OTP')
    //     window.sendOtp(
    //       mobileWithCountryCode,
    //       () => {
    //         console.log('OTP sent');
    //         setOtpModalOpen(true); // 👉 OPEN POPUP
    //       },
    //       (err) => {
    //         console.log('Error sending OTP', err);
    //       }
    //     );
    //     console.log('debug:after sending OTP')

    //   } else {
    //     // STEP 2: Verify OTP
    //     window.verifyOtp(
    //       otp,
    //       (data) => {
    //         console.log('OTP verified');

    //         // STEP 3: Submit form after verification
    //         setSubmitted(true);
    //         leadServiceHelper.submitMobileNumberService(form, () => {
    //           setTimeout(() => setSubmitted(false), 2000);
    //           setForm({ name: '', mobile: '', email: '' });
    //           setOtp('');
    //           setOtpSent(false);
    //           navigate('/products/premium/thankyou', { state: { product: 'premium' } });
    //         });
    //       },
    //       (err) => {
    //         console.log('Invalid OTP', err);
    //       }
    //     );
    //   }
    // };

    const toggleExpand = () => {
      if (!expanded) {
        setProductFeatures(features);
        setExpanded(!expanded);
      }else {
        setProductFeatures(features.slice(0, 4));
        setExpanded(!expanded);
        // setTimeout(2000,()=>{document.getElementById('expand_collapse').scrollIntoView({ behavior: 'smooth' })});
      }
    };

    useEffect(() => {
        document.title = "Niveza - Premium Plan";
        // Load Elfsight script only once
        const scriptId = 'elfsight-platform-script';
        if (!document.getElementById(scriptId)) {
          const script = document.createElement('script');
          script.id = scriptId;
          script.src = 'https://elfsightcdn.com/platform.js';
          script.async = true;
          document.body.appendChild(script);
        }
    }, []);

    useEffect(() => {
      document.title = "Niveza - Premium Plan";

      // Load MSG91 OTP script
      const scriptId = 'msg91-otp-script';
      if (!document.getElementById(scriptId)) {
        const script = document.createElement('script');
        script.id = scriptId;
        script.src = 'https://verify.msg91.com/otp-provider.js';
        script.async = true;
        script.onload = () => {
          window.initSendOTP({
            widgetId: "3664726c4d71303030313730",
            tokenAuth: "509738T0XJCM4sn69e3adc3P1",
            exposeMethods: true,
            success: (data) => console.log('OTP success', data),
            failure: (err) => console.log('OTP failure', err),
          });
        };
        document.body.appendChild(script);
      }
    }, []);


    const handleVerifyOtp = () => {
      if (!otp) {
        alert("Please enter OTP");
        return;
      }
      window.verifyOtp(
          otp,
          (data) => {
            console.log("OTP verified");

            setOtpModalOpen(false);

            // 👉 Submit after success
            setSubmitted(true);
            leadServiceHelper.submitMobileNumberService(form, () => {
              setTimeout(() => setSubmitted(false), 2000);
              setForm({ name: '', mobile: '', email: '' });
              setOtp('');
              navigate('/products/premium/thankyou', { state: { product: 'premium' } });
            });
          },
          (err) => {
            console.log("Invalid OTP", err);
            alert("Invalid OTP");
          }
        );
  };


    return (
        <>
            <Headers/>
            <Celebration/>
            {window.innerWidth >= 500 ?
            <div className="top-price">
              <div className="premium-footer">
                  <div className="premium-price">
                      {/* <span style={{fontFamily:'bold',color:'white'}}>Start with </span> */}
                      <div><span className="premium-price-value">₹ 20,000</span> <span className="premium-price-gst">+GST</span></div>
                  </div>
                  <div className="premium-contact-form-container" >
                      <div className="premium-form-section" >
                        <form className="premium-form" onSubmit={handleFormSubmit}>
                          <div>
                            <input
                              type="tel"
                              name="mobile"
                              placeholder= {window.innerWidth <= 500 ? "Mobile Number" : "Enter mobile number"}  
                              className= 'premium-form-input'
                              value={form.mobile}
                              onChange={handleFormChange}
                              pattern="^(?:\d-?){10}$"
                              required
                              onInvalid={e => e.target.setCustomValidity("Please enter a valid 10‑digit mobile number")} 
                              onInput={e => e.target.setCustomValidity("")}
                            />
                            <button type="submit" disabled={submitted} >
                              {submitted ? 'Submitted!' : 'Get a call back'}
                            </button>
                          </div>
                        </form>
                      </div>
                      <span className='cta_or'>Or</span>
                      <div className="premium-contact">
                        {window.innerWidth <= 500 ? <span style={{fontFamily:'bold'}}>Click to call</span> : <></>}  
                        <span className="premium-contact-phone">{window.innerWidth <= 500 ? <a href="tel:+919607527770">+91-96075-27770</a> : <span style={{fontFamily:'bold',color:'white'}}>+91-96075-27770</span>} </span>
                      </div>
                  </div>
              </div>
            </div> : ''}
            <div  className="premium-container">
                <div className="premium-header">
                  <img src="/images/premium/logo_p360.png" alt="Premium" className="premium-logo" />
                  <span className="premium-title">
                      More than <span className='highlight'>25% Returns Objective<sup>*</sup> Over 12 Months</span>
                  </span>
                </div>
                <div className="premium-features">
                {productFeatures.map((f, i) => (
                    <div className="premium-feature" key={i}>
                    <img src={f.icon} alt={f.title} className="premium-feature-icon" />
                    <div>
                        <div className="premium-feature-title">{f.title}</div>
                        <div className="premium-feature-desc">{f.desc}</div>
                    </div>
                    </div>
                ))}
                </div>
                <div onClick={toggleExpand} className="expand-text"> {expanded? '<<Click to see less' : 'Click to see more>>'}</div> 

                {/* {
                  window.innerWidth <= 500 ?
                    <div onClick={toggleExpand} className="expand-text"> {expanded? '<<Click to see less' : 'Click to see more>>'}</div> : ' '
                } */}

                <div style={{ paddingBottom:'8px', marginTop:'40px' }}>
                  <span style={{display: 'block',width: '100%',textAlign: 'center',fontWeight:'bold',color:'black',fontSize:'clamp(1.3rem, 4vw, 1.6rem)'}}>Latest Research <span className='highlight'>Calls You Missed</span></span>
                </div>

                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                  <div ref={prevRef} style={{ cursor: 'pointer' }}>
                    {/* <BiArrowFromRight size={44} /> */}
                    <button
                      style={{
                        backgroundColor: "#3cb371",
                        border: "none",
                        borderRadius: "50%",
                        width: "45px",
                        height: "45px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                      }}
                    >
                      <FaAngleLeft color="white" size={28} />
                    </button>  
                  </div>
                  {swiperReady && (
                    <Swiper
                      modules={[Navigation]}
                      spaceBetween={56}
                      slidesPerView={"auto"}
                      grabCursor={true}
                      style={{ padding: "1rem" }}

                      loop={true}
                      navigation={{
                        prevEl: prevRef.current,
                        nextEl: nextRef.current,
                      }}
                      onBeforeInit={(swiper) => {
                        swiper.params.navigation.prevEl = prevRef.current;
                        swiper.params.navigation.nextEl = nextRef.current;
                      }}
                      breakpoints={{
                        320: { slidesPerView: 1 },
                        600: { slidesPerView: 2 },
                        900: { slidesPerView: 3 },
                        1200: { slidesPerView: 3 },
                      }}
                    >
                      {researchCalls.map((call, i) => (
                        <SwiperSlide key={i} className="slider-card" >
                          <StatisticCard
                            className="statistic-card"
                            style={{  border: '2px solid #3cb371' }}
                          >
                            <div className='statsDesc'>
                              <div>
                                {
                                window.innerWidth >= 500 ?
                                  <>
                                    <div style={{ textAlign:'center'}}><span style={{ fontWeight: 'bold',fontSize:'18px'}}>{call.name}</span></div>
                                    <br></br>
                                    <div className='returns'>Returns: &nbsp;&nbsp;&nbsp;<b>{call.returns}{call.trend>0?<FaArrowUp color='green'/>:<FaArrowDown color='red'/>}</b></div>
                                    <div>Entry Price: &nbsp;&nbsp; <b>{call.entry}</b></div>
                                    <div>Entry Date: &nbsp;&nbsp;&nbsp; <b>{call.entryDate}</b></div>
                                    <div>Exit Price:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  <b>{call.exit}</b></div>
                                    <div>Exit Date: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <b>{call.exitDate}</b></div>
                                  </>:
                                  <>
                                    <div style={{ textAlign:'center'}}><span style={{ fontWeight: 'bold',fontSize:'18px' }}>{call.name}</span></div>
                                    <br></br>
                                    <div className='returns'>Returns:&nbsp;&nbsp;<b>{call.returns}{call.trend>0?<FaArrowUp color='green'/>:<FaArrowDown color='red'/>}</b></div>
                                    <div>Entry Price:&nbsp;<b>{call.entry}</b></div>
                                    <div>Entry Date:&nbsp;<b>{call.entryDate}</b></div>
                                    <div>Exit Price:&nbsp;&nbsp;&nbsp;<b>{call.exit}</b></div>
                                    <div>Exit Date:&nbsp;&nbsp;&nbsp;<b>{call.exitDate}</b></div>
                                  </>
                                }
                              </div>
                            </div>
                          </StatisticCard>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  )}
                  <div ref={nextRef} style={{ cursor: 'pointer' }}>
                    {/* <BiArrowFromLeft size={44} /> */}
                    <button
                      style={{
                        backgroundColor: "#3cb371",
                        border: "none",
                        borderRadius: "50%",
                        width: "45px",
                        height: "45px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                      }}
                    >
                      <FaAngleRight color="white" size={28} />
                    </button>   
                  </div>
                </div>



                {/* <div>
                  <div  className="google-reviews-section">
                      <div className="elfsight-app-28d4333b-031d-43dd-a616-8a3ae9781d51" data-elfsight-app-lazy></div>
                  </div>
                </div>  */}

              {/* <script src="https://elfsightcdn.com/platform.js" async></script> */}
              <div style={{marginRight:"21px",marginLeft:"26px"}}>
                <div class="elfsight-app-b0efdf6e-91e0-446f-869a-399f7905e1fc" data-elfsight-app-lazy></div>
              </div>

              {window.innerWidth <= 500 ?
                <div className="premium-footer">
                    <div className="premium-price">
                        <span style={{fontFamily:'bold'}}>Start with </span>
                        <div><span className="premium-price-value">₹ 20,000</span> <span className="premium-price-gst">+GST</span></div>
                    </div>
                    <div className="premium-contact-form-container" >
                        <div className="premium-form-section" >
                          <form className="premium-form" onSubmit={handleFormSubmit}>
                            <div>
                              <input
                                type="tel"
                                name="mobile"
                                placeholder= {window.innerWidth <= 500 ? "Mobile Number" : "Enter mobile number"}  
                                className= 'premium-form-input'
                                value={form.mobile}
                                onChange={handleFormChange}
                                pattern="^(?:\d-?){10}$"
                                required
                                onInvalid={e => e.target.setCustomValidity("Please enter a valid 10‑digit mobile number")} 
                                onInput={e => e.target.setCustomValidity("")}
                              />
                              <button type="submit" disabled={submitted} >
                                {submitted ? 'Submitted!' : 'Get a call back'}
                              </button>
                            </div>
                          </form>
                        </div>
                        <span className='cta_or'>Or</span>
                        <div className="premium-contact">
                          {window.innerWidth <= 500 ? <span style={{fontFamily:'bold'}}>Click to call</span> : <></>}  
                          <span className="premium-contact-phone">{window.innerWidth <= 500 ? <a href="tel:+919607527770">+91-96075-27770</a> : <span style={{fontFamily:'bold',color:'black'}}>+91-96075-27770</span>} </span>
                        </div>
                    </div>
                </div> : ''}
                {/* <YouTube id="2l2GXPlfi4Q" /> */}
                
                <div className="video-reviews-header">
                  <h2>
                    Client <span>Video Testimonials</span>
                  </h2>
                  <p>Real feedback from our satisfied customers</p>
                </div>
                <YoutubeTestimonials/>
              <div className="video-reviews-header">
                <h2>
                  Want to Explore <span>Other Products?</span>
                </h2>
              </div>
              <ProductCards plans={plans}/>

            </div>
            
            <p style={{textAlign: 'center',fontFamily:'bold',color:'grey',fontSize:'0.8rem'}}>*Investments in stocks are subject to market risk. There is no assurance or gaurantee that objectives of the products on this site will be achieved.</p>
            <Footer/>
            {otpModalOpen && (
              <div style={styles.overlay}>
                <div style={styles.modal}>
                  <h3>Enter OTP</h3>

                  <input
                    type="text"
                    placeholder="Enter OTP"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    style={styles.input}
                  />

                  <div style={{ marginTop: "10px" }}>
                    <button onClick={handleVerifyOtp} style={styles.verifyBtn}>
                      Verify OTP
                    </button>

                    <button
                      onClick={() => window.retryOtp(null)}
                      style={styles.resendBtn}
                    >
                      Resend OTP
                    </button>
                  </div>

                  <button onClick={() => setOtpModalOpen(false)} style={styles.closeBtn}>
                    ✕
                  </button>
                </div>
              </div>
            )}
        </>
    )
};


const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
  modal: {
    background: "#fff",
    padding: "20px",
    borderRadius: "10px",
    width: "300px",
    textAlign: "center",
    position: "relative",
  },
  input: {
    width: "100%",
    padding: "10px",
    marginTop: "10px",
  },
  verifyBtn: {
    padding: "10px",
    marginRight: "10px",
    background: "#3cb371",
    color: "#fff",
    border: "none",
    cursor: "pointer",
  },
  resendBtn: {
    padding: "10px",
    background: "#ccc",
    border: "none",
    cursor: "pointer",
  },
  closeBtn: {
    position: "absolute",
    top: "5px",
    right: "10px",
    border: "none",
    background: "transparent",
    fontSize: "18px",
    cursor: "pointer",
  },
};

export default Premium;